import React, { useEffect, useState } from "react";

// Airline on the new mobile date card: a round logo badge beside the date, or the airline name when there is no logo.
const DepartureAirline = (props: { name?: string; logo?: string }) => {
  const { name, logo } = props;
  const [logoFailed, setLogoFailed] = useState(false);
  const [logoSquare, setLogoSquare] = useState(false);

  useEffect(() => { setLogoFailed(false); setLogoSquare(false); }, [logo]);

  // A picture logo (roughly square) fills the circle; a wider logo (a word, or an icon with a word) stays whole inside it.
  const onLogoLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
    setLogoSquare(w > 0 && h > 0 && w / h >= 0.8 && w / h <= 1.25);
  };

  if (logo && !logoFailed) {
    return (
      <div className={`departure-airline is-badge is-head${logoSquare ? " is-fill" : ""}`} title={name || undefined}>
        <img
          className="departure-airline_logo"
          src={logo}
          alt={name || "Airline"}
          draggable={false}
          onLoad={onLogoLoad}
          onError={() => setLogoFailed(true)}
        />
      </div>
    );
  }

  if (!name) return null;

  return (
    <div className="departure-airline is-name is-head" title={name}>
      <div className="departure-airline_name">{name}</div>
    </div>
  );
};

export default DepartureAirline;
